import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const initStateApipayCheckout = {
  apipayCheckout: { data: null, loading: false, error: null },
};

export const apipayCheckout = createAsyncThunk(
  "payment/apipayCheckout",
  async (data, { rejectWithValue, fulfillWithValue }) => {
    const token = localStorage.getItem("token");
    if (!token) return rejectWithValue({ error: "Необходима авторизация" });

    return await axios
      .post(`${process.env.REACT_APP_SERVER_API}/payments/apipay/checkout/`, data, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((res) => fulfillWithValue(res.data))
      .catch((res) =>
        rejectWithValue(res.response?.data || { error: "Ошибка при создании заказа" })
      );
  }
);

export const reducerApipayCheckout = {
  [apipayCheckout.pending]: (state) => {
    state.apipayCheckout.loading = true;
    state.apipayCheckout.error = null;
  },
  [apipayCheckout.fulfilled]: (state, action) => {
    state.apipayCheckout.loading = false;
    state.apipayCheckout.data = action.payload;
    state.apipayCheckout.error = null;
  },
  [apipayCheckout.rejected]: (state, action) => {
    state.apipayCheckout.loading = false;
    state.apipayCheckout.data = null;
    state.apipayCheckout.error = action.payload;
  },
};

